const humanizeGlossary = ({
  glossary, block = '', term = '', isSingular = true,
}) => {
  const { items: glossaryItems = glossary } = glossary;
  const { [block]: blockItems = {} } = glossaryItems;
  const { items = blockItems } = blockItems;
  const { [term]: blockTerm = {} } = items;
  const { singular = '', plural = '' } = blockTerm;
  return isSingular ? singular : plural
};

export { humanizeGlossary as default };
//# sourceMappingURL=humanize-glossary.js.map
